import { styled } from '@moleculeone/ui';

export const CenteredContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '4rem',
});
